module.exports = __webpack_public_path__ + "img/Psych_text04a_goaldots.a070bc7e.png";